/**
 * @desc 导入费用映射
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costItemMapping/importCostMappingExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
